import { render, staticRenderFns } from "./CheckboxComponent.vue?vue&type=template&id=7a45abc4"
import script from "./CheckboxComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxComponent.vue?vue&type=script&lang=js"
import style0 from "./CheckboxComponent.vue?vue&type=style&index=0&id=7a45abc4&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a45abc4')) {
      api.createRecord('7a45abc4', component.options)
    } else {
      api.reload('7a45abc4', component.options)
    }
    module.hot.accept("./CheckboxComponent.vue?vue&type=template&id=7a45abc4", function () {
      api.rerender('7a45abc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/CheckboxComponent.vue"
export default component.exports